module.exports = __webpack_public_path__ + "assets/img/icon_music_pause-9466846c.png";